import {
  ALERT_ERROR,
  ALERT_HIDE,
  ALERT_SUCCESS,
  APP_SETTINGS_SET,
  PRE_LOADER_HIDE,
  PRE_LOADER_SHOW
} from "../utils/Constant";
import {STATUS_ERROR, STATUS_SUCCESS} from "../components/Alert";

const initState = {
  cityList: [],
  contactInfo: {},
  alert: {}
};
const app = function (state = initState, action) {

  switch (action.type) {
    case APP_SETTINGS_SET:
      return {...state, ...action.data};
    case ALERT_SUCCESS:
      if (!action.data.status) {
        return state;
      }
      return {
        ...state, alert: {
          visible: true,
          type: action.data.status === 200 ? STATUS_SUCCESS : STATUS_ERROR,
          message: action.data.message || '',
          errors: action.data.errors || {},
        }
      };
    case ALERT_ERROR:

      if (!action.data || !action.data.content || !action.data.message) {
        return state;
      }

      return {
        ...state, alert: {
          visible: true,
          type: STATUS_ERROR,
          message: action.data.message || 'Ошибка сервера попробуйте позднее',
        }
      };
    case ALERT_HIDE:
      return {
        ...state, alert: {
          visible: false,
          type: '',
          message: ' ',
        }
      };
    case PRE_LOADER_SHOW:

      return {
        ...state, loader: {
          visible: true,
          //message: action.data.message || 'Загрузка...',
        }
      };


    case PRE_LOADER_HIDE:
      return {
        ...state, loader: {
          visible: false,
          message: '',
        }
      };
    default :
      return state;
  }
}

export default app;
